export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          关于歪歪漫画
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          了解我们的故事与初心
        </p>
        <div className="max-w-3xl mx-auto bg-background-50 rounded-xl border border-background-200 p-8 md:p-10">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 flex items-center justify-center rounded-2xl bg-primary-500 text-background-50">
              <span className="text-3xl md:text-4xl font-bold font-heading">歪</span>
            </div>
            <div>
              <h3 className="text-lg font-bold font-heading text-foreground-900 mb-4">
                让每一个漫画爱好者都能免费看好漫画
              </h3>
              <div className="space-y-3 text-sm text-foreground-600 leading-relaxed">
                <p>
                  歪歪漫画网创立于对漫画的热爱。我们深知追更的快乐与等待的煎熬，因此搭建了这个汇聚海量漫画资源的阅读平台。从韩漫的细腻画风到日漫的经典叙事，再到国漫的崛起之作，我们用心筛选每一部作品，只为给你最好的阅读体验。
                </p>
                <p>
                  平台坚持免费开放原则，所有漫画资源均可免费在线观看与阅读。我们采用先进的下拉式阅读技术，无论是手机还是电脑，都能享受丝滑流畅的翻页体验。每日更新超过200部热门连载，确保追更党不错过任何精彩。
                </p>
                <p>
                  未来，歪歪漫画网将继续扩展漫画资源库，优化阅读体验，努力成为中文漫画爱好者最信赖的在线漫画家园。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}